
/* eslint-disable no-useless-escape */
export const isText = RegExp(/^[a-zA-Z ]+$/);
export const isName = RegExp(/^[a-zA-Z ]+$/);
export const isCardNumber = RegExp(/^([+]\d{2})?\d{16}$/);
export const isCvv = RegExp(/^([+]\d{2})?\d{3}$/);
export const isEmail = RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);
export const isPhone = RegExp(/^([+]\d{2})?\d{8,15}$/);
export const isExpiary = RegExp(/^([+]\d{2})?\d{4}$/);
export const isPassword = RegExp(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
);
export const adress = RegExp(/^[a-zA-Z0-9\s\-.,']{2,}$/);
export const addresLength = RegExp(/^.{2,100}$/);
export const isOtp = RegExp(/^[0-9 ]{4}/i);
export const alphanumeric = RegExp(/^[a-zA-Z0-9\s]+$/);
export const isParagraph = /^[a-zA-Z0-9\s.,/-;:?!'"()\-]+$/;
export const isNumber = RegExp(/^\d+$/);
// VAT / GST / income-tax numbers: formats differ by country (e.g. "GB 123 4567 89",
// "22AAAAA0000A1Z5", "12.345.678/0001-95", "CHE-123.456.789 MWST"), so allow letters
// (any script), digits, spaces and common separators; must contain at least one letter or digit.
export const isTaxNumber = /^(?=.*[\p{L}\p{N}])[\p{L}\p{N}\s.\-/\\&()_,:#+]{2,50}$/u;
export const TAX_NUMBER_ERROR =
  "Use 2-50 letters, numbers, spaces or - . / \\ & ( ) _ , : # +";

export const CreateInvoiceValidation = {
  // Customer Details
  customer1: {
    required: true,
    error: "Please select a customer"
  },
  country1: {
    required: true,
    pattern: /^[A-Za-z\s]+$/,
    error: "Country must contain only letters and spaces"
  },
  address1: {
    required: true,
    minLength: 10,
    maxLength: 100,
    pattern: /^[A-Za-z0-9\s,]+$/,
    error: "Address must be between 10-100 characters and can only contain letters, numbers, spaces and commas"
  },
  city1: {
    required: true,
    minLength: 2,
    maxLength: 50,
    pattern: /^[A-Za-z\s]+$/,
    error: "City must contain only letters and spaces, between 2-50 characters"
  },
  state1: {
    required: true,
    minLength: 10,
    maxLength: 100,
    pattern: /^[A-Za-z\s]+$/,
    error: "State must contain only letters, between 10-100 characters"
  },
  pincode1: {
    required: true,
    pattern: /^\d{5,6}$/,
    error: "Pincode must be 5-6 digits"
  },
  phone1: {
    required: true,
    pattern: /^\+\d{1,4}\s\d{10,15}$/,
    error: "Phone must be in format: +CountryCode Number (10-15 digits)"
  },
  // Invoice Details
  invoiceDate1: {
    required: true,
    validate: (value) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const inputDate = new Date(value);
      return inputDate <= today;
    },
    error: "Invoice date cannot be in the future"
  },
  paymentTerms1: {
    required: true,
    error: "Please select payment terms"
  },
  dueDate1: {
    required: true,
    validate: (value, { invoiceDate }) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const inputDate = new Date(value);
      const invDate = new Date(invoiceDate);
      return inputDate >= invDate && inputDate >= today;
    },
    error: "Due date must be after or equal to invoice date and not in the past"
  },
  penaltyAmount1: {
    required: true,
    pattern: /^\d+(\.\d{1,2})?$/,
    error: "Penalty amount must be a positive number with max 2 decimal places"
  },
  otherInfo1: {
    required: false,
    maxLength: 300,
    error: "Other info cannot exceed 300 characters"
  },
  // Product Details
  product1: {
    required: true,
    pattern: /^[A-Za-z0-9\s]+$/,
    error: "Product must contain only letters, numbers and spaces"
  },
  description1: {
    required: true,
    minLength: 5,
    maxLength: 500,
    error: "Description must be between 5-500 characters"
  },
  unitCost1: {
    required: true,
    pattern: /^\d+(\.\d{1,2})?$/,
    error: "Unit cost must be a positive number with max 2 decimal places"
  },
  discount1: {
    required: false,
    pattern: /^(?:100|\d{1,2}(?:\.\d{1,2})?)$/,
    error: "Discount must be between 0-100"
  },
  tax1: {
    required: false,
    pattern: /^(?:100|\d{1,2}(?:\.\d{1,2})?)$/,
    error: "Tax must be between 0-100"
  },
  // Recurring Invoice Details
  profileName1: {
    required: true,
    pattern: /^[A-Za-z0-9\s]+$/,
    error: "Profile name must contain only letters, numbers and spaces"
  },
  repeatEvery1: {
    required: true,
    error: "Please select repeat frequency"
  },
  startDate1: {
    required: true,
    validate: (value) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const inputDate = new Date(value);
      return inputDate >= today;
    },
    error: "Start date must be today or a future date"
  },
  endDate1: {
    required: false,
    validate: (value, { startDate }) => {
      if (!value) return true;
      const start = new Date(startDate);
      const end = new Date(value);
      return end > start;
    },
    error: "End date must be after start date"
  }
};

export const AddNewEmployeeValidation = {
  firstName: {
    required: true,
    validator: {
      regEx: isText,
      error: "First name must contain only letters",
      errEmpty: "First name is required",
    },
  },
  nickName: {
    required: false,
    validator: {
      regEx: isText,
      errEmpty: "Nick name must contain only letters",
      error: "nick name is required",
    },
  },
  lastName: {
    required: true,
    validator: {
      regEx: isText,
      error: "Surname must contain only letters",
    },
  },

  isActive: {
    required: true,
    validator: {
      regEx: true || false,
      error: "Rate is required",
    },
  },

  gender: {
    required: true,
    validator: {
      regEx: /^(male|female|other)$/i,
      error: "Please select a valid gender",
    },
  },
  mobile: {
    required: false,
    validator: {
      regEx: isPhone,
      error: "Mobile number must be in digits",
      errEmpty: "Mobile is required",
    },
  },
  password: {
    required: true,
    validator: {
      regEx:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      error:
        "Password must be at least 8 characters long and contain at least one digit, one lowercase letter, and one uppercase letter",
    },
  },
  confirmPassword: {
    required: true,
    validator: {
      regEx:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      error: "Password does not match",
    },
  },
  jobPosition: {
    required: true,
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "Job position must contain only letters and spaces",
    },
  },
  department: {
    required: true,
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "Department must contain only letters and spaces",
    },
  },
  operator: {
    required: false,
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "Role Type must contain only letters and spaces",
    },
  },
  address1: {
    required: true,
    validator: {
      regEx: /^[a-zA-Z0-9\s\/#_,\-]+$/,
      error: "Invalid Address Format",
    },
  },
  address2: {
    required: false, // Assuming this is optional
    validator: {
      regEx: /^[a-zA-Z0-9\s\/#_,.\-']+$/,
      error: "Invalid Address 2 Format",
    },
  },
  city: {
    required: true,
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "City must contain only letters and spaces",
    },
  },
  zipCode: {
    required: true,
    validator: {
      regEx: /^\d+$/,
      error: "Zip code must contain numbers only",
    },
  },
  country: {
    required: true,
    validator: {
      regEx: /^[a-zA-Z\s,']+$/,
      error: "Country must contain only letters",
    },
  },
  accountType: {
    required: true,
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "Country must contain only letters and spaces",
    },
  },
  email: {
    required: true,
    validator: {
      regEx: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      error: "Please enter a valid email address",
    },
  },
  dob: {
    required: true,
    validator: {
      regEx: /^\d{4}-\d{2}-\d{2}$/,
      error: "Please enter a valid date of birth in the format YYYY-MM-DD",
    },
  },
  issuedDate: {
    required: true,
    validator: {
      regEx: /^\d{4}-\d{2}-\d{2}$/,
      error: "Please enter a valid date of birth in the format YYYY-MM-DD",
    },
  },
  education: {
    required: false, // Assuming this is optional
    validator: {
      regEx: alphanumeric,
      error: "Education must contain only letters, numbers and spaces",
    },
  },
  empType: {
    required: true, // Assuming this is optional
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "Choose Employee Type",
    },
  },

  salary: {
    required: true,
    validator: {
      regEx: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
      min: 0,
      error: "Please enter a valid salary (should be zero or positive)",
      minError: "Value should not be negative",
    },
  },
  increment: {
    required: false,
    validator: {
      regEx: /^\d+(\.\d{1,2})?$/,
      error: "Please enter a valid increment",
    },
  },
  profileImg: {
    required: false,
    validator: {
      regEx: /\.(jpg|jpeg|png|gif)$/,
      error: "Please upload a valid image file (jpg, jpeg, png, gif)",
    },
  },
  nationality: {
    required: true,
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "Nationality must contain only letters and spaces",
    },
  },

  payrollName: {
    required: false,
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "payrollName must contain only letters and spaces",
    },
  },
  leaveBalance: {
    required: true,
    validator: {
      regEx: /^(?:[0-9]|[1-9][0-9]|[1-2][0-9]{2}|3[0-5][0-9]|360|365)$/,
      min: 0,
      max: 365,
      error: "Leave balance must be a number between 0 and 365 days",
      maxError: "Leave balance must be a number between 0 and 365 days",
    },
  },
  religion: {
    required: false,
    validator: {
      regEx: isText,
      error: "Religion must contain only letters and spaces",
    },
  },
  marital: {
    required: false,
    validator: {
      regEx: /^(Yes|No)$/i,
      error: "Please select a valid marital status",
    },
  },
  passportNum: {
    required: true,
    validator: {
      regEx: /^[a-zA-Z0-9]+$/,
      error: "Passport number must contain only letters and numbers",
    },
  },
  empNumber: {
    required: false,
    validator: {
      regEx: /^[a-zA-Z0-9]+$/,
      error: "Employee number must contain only letters and numbers",
    },
  },

  emergencyContact: {
    required: false,
    validator: {
      regEx: /^\d{10,13}$/,
      error: "Emergency contact number must be 10 digits",
    },
  },
  workplace: {
    required: false,
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "Workplace must contain only letters and spaces",
    },
  },
  status: {
    required: false,
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "Status must contain only letters and spaces",
    },
  },
  hourlyRate: {
    required: true,
    validator: {
      regEx: /^(Salary|Hourly)$/,
      error: "Please enter a valid hourly rate",
    },
  },
  bankName: {
    required: true,
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "Bank name must contain only letters and spaces",
    },
  },
  accountNum: {
    required: true,
    validator: {
      regEx: /^\d{6,}$/,  // Regex for at least 6 digits
      error: "Account number must contain at least 6 digits and only digits are allowed",
    },
  },

  ifscCode: {
    required: false,
    validator: {
      regEx: /^[A-Z0-9]{8}$|^[A-Z0-9]{11}$/,
      error: "Should be in capital letter and must contain 8 or 11 characters",
    },
  },
  accountHolder: {
    required: true,
    validator: {
      regEx: isParagraph,
      error: "Account holder name must contain only letters and spaces",
    },
  },
  personalTaxCode: {
    required: false,
    validator: {
      regEx: /^[a-zA-Z0-9]+$/,
      error: "Personal tax code must contain only letters and digits",
    },
  },
  joiningDate: {
    required: true,
    validator: {
      regEx: /^\d{4}-\d{2}-\d{2}$/,
      error: "Please enter a valid Joining Date",
    },
  },
  experience: {
    required: true,
    validator: {
      regEx: /^\d+$/,
      error: "Experience must contain digits",
    },
  },
  profileVisibility: {
    required: false, // Assuming this is optional
    validator: {
      regEx: /^(true|false)$/,
      error: "Profile visibility must be either true or false",
    },
  },
  taskNoti: {
    required: false, // Assuming this is optional
    validator: {
      regEx: /^(true|false)$/,
      error: "Task notifications must be either true or false",
    },
  },
  ispreAttendance: {
    required: false, // Assuming this is optional
    validator: {
      regEx: /^(true|false)$/,
      error: "Task notifications must be either true or false",
    },
  },
  isOverTime: {
    required: false, // Assuming this is optional
    validator: {
      regEx: /^(true|false)$/,
      error: "OverTime must be either true or false",
    },
  },
  isSdl: {
    required: false, // Assuming this is optional
    validator: {
      regEx: /^(true|false)$/,
      error: "SDL must be either true or false",
    },
  },

  urlSkype: {
    required: false, // Assuming this is optional
    validator: {
      regEx:
        /^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/,
      error: "Please enter a valid Skype URL",
    },
  },
  urlLinkedin: {
    required: false, // Assuming this is optional
    validator: {
      regEx:
        /^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/,
      error: "Please enter a valid LinkedIn URL",
    },
  },
  urlInsta: {
    required: false, // Assuming this is optional
    validator: {
      regEx:
        /^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/,
      error: "Please enter a valid Instagram URL",
    },
  },
  urlFb: {
    required: false, // Assuming this is optional
    validator: {
      regEx:
        /^(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?$/,
      error: "Please enter a valid Facebook URL",
    },
  },
  idNumber: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9]{5,30}$/,
      error: "ID Number must be 5-30 alphanumeric characters",
      errEmpty: "ID Number is required",
    },
  },
  taxRefNo: {
    required: false, // optional: employees not yet registered for tax may have none
    validator: {
      regEx: /^[A-Za-z0-9\-]{5,30}$/,
      error: "Tax Reference Number must be 5-30 alphanumeric characters or hyphens",
      errEmpty: "Tax Reference Number is required",
    },
  },
  medicalAidNo: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9\-]{5,30}$/,
      error: "Medical Aid Number must be 5-30 alphanumeric characters or hyphens",
      errEmpty: "Medical Aid Number is required",
    },
  },
};

export const ValidationAddRecruitment = {
  position: {
    required: true,
    validator: {
      regEx: isText,
      error: "Please select Position",
    },
  },
  company: {
    required: true,
    validator: {
      regEx: isText,
      error: "Please select Company",
    },
  },
  quantity: {
    required: true,
    validator: {
      regEx: isText,
      error: "Please select Quantity",
    },
  },
  workingFrom: {
    required: true,
    validator: {
      regEx: isText,
      error: "Please enter Working From",
    },
  },
  department: {
    required: true,
    validator: {
      regEx: isText,
      error: "Please select Department",
    },
  },
  workplace: {
    required: true,
    validator: {
      regEx: isText,
      error: "Please select Workplace",
    },
  },
  startingSalaryFrom: {
    required: true,
    validator: {
      regEx: isText,
      error: "Please select Salary Range",
    },
  },
  startingSalaryTo: {
    required: true,
    validator: {
      regEx: isText,
      error: "Please select Salary Range",
    },
  },
  displaySalary: {
    required: false,
    validator: {
      regEx: isText,
      error: "Please select Position",
    },
  },
  reason: {
    required: true,
    validator: {
      regEx: isParagraph,
      error: "Please enter Reason",
    },
  },
  desc: {
    required: true,
    validator: {
      regEx: isParagraph,
      error: "Please enter Description",
    },
  },
};
export const ValidationAttendanceReq = {
  checkIn: {
    required: true,
    validator: {
      regEx: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
      error: "Invalid time format. Please use the format 'hh:mm'.",
    },
  },
  checkOut: {
    required: true,
    validator: {
      regEx: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
      error: "Invalid time format. Please use the format 'hh:mm'.",
    },
  },
  remarks: {
    required: false,
    validator: {
      regEx: /^[a-zA-Z0-9\s]+$/,
      error: "No special character allowed",
    },
  },
};
export const register = {
  firstName: {
    required: true,
    validator: {
      regEx: isText,
      error: "Please provide a valid first name ",
      errEmpty: "First Name is a required field",
    },
    length: {
      value: 20,
      error: "Entered text should be between 2-20",
    },
  },
  lastName: {
    required: true,
    validator: {
      regEx: isText,
      // length: 10,
      error: "Please provide a valid last name ",
      errEmpty: "Last Name is a required field",
    },
    length: {
      value: 20,
      error: "Entered text should be between 2-20",
    },
  },
  mobile: {
    required: true,
    validator: {
      mobileValidate: {
        regEx: isPhone,
        error: "Entered text should be between 8-15",
      },
      errEmpty: "Mobile is a required field",
    },
    // minLength:{
    //   value: 8,
    //   error: 'entered text should be between 8-15',
    // },
    // length:{
    //   value:15,
    //   error:`Phone Number should be between 8-15`,
    // }
  },
  email: {
    required: true,
    validator: {
      regEx: isEmail,
      error: "Invalid email format.",
      errEmpty: "Email is a required field",
    },
  },
  line1: {
    required: true,
    validator: {
      regEx: adress,
      error: "Please provide a valid Address ",
      errEmpty: "Address line 1 is a required field",
    },
    // length: {
    //   value: 20,
    //   error: 'entered text should be between 2-20',
    // },
    minLength: {
      value: 2,
      error: "Entered text should be between 2-20",
    },
  },
  line2: {
    required: true,
    validator: {
      regEx: adress,
      error: "Please provide a valid Address ",
      errEmpty: "Address line 2 is a required field",
    },
    // length: {
    //   minLength:2,
    //   value: 20,
    //   error: 'entered text should be between 2-20',
    // },
    minLength: {
      value: 2,
      error: "Entered text should be between 2-20",
    },
  },
  password: {
    required: true,
    validator: {
      regEx: isPassword,
      errEmpty: "Password is a required field",
      error:
        "Password must contain at least 8 characters\n,one capital, special character and number.",
      // 'Password must contain at least 8 characters, including a mix of uppercase and lowercase letters, numbers, and special characters.',
    },
  },
  confirmPassword: {
    required: true,
    validator: {
      regEx: isPassword,
      // value: true,
      errEmpty: "Confirm Password is a required field",
      error: "Password does not match.",
    },
  },
};

export const SigninValidate = {
  email: {
    required: true,
    validator: {
      regEx: isEmail,
      error: "Please enter a valid email",
    },
  },
  password: {
    required: true,
    validator: {
      regEx: isPassword,
      error: "Invalid Password",
    },
  },
};
export const SignUpValidate = {
  firstName: {
    required: true,
    validator: {
      regEx: isText,
      error: "First name must contain only letters",
      errEmpty: "First name is required",
    },
  },
  lastName: {
    required: true,
    validator: {
      regEx: /^[a-zA-Z]+$/,
      error: "Last name must contain only letters",
    },
  },
  phone: {
    required: true,
    validator: {
      regEx: /^\d+$/,
      error: "Phone must contain only numbers",
      errEmpty: "Phone is required",
    },
  },
  countryCode: {
    required: true,
    validator: {
      errEmpty: "Country code is required",
    },
  },
  terms: {
    required: true,
    validator: {
      errEmpty: "Terms & Conditions is required",
    },
  },

  email: {
    required: true,
    validator: {
      regEx: isEmail,
      error: "Please enter a valid email",
    },
  },
  password: {
    required: true,
    validator: {
      regEx:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      error:
        "Password must be at least 8 characters long, include one uppercase letter, one lowercase letter, one number, and one special character. Spaces are not allowed.",
    },
  },
  confirmPassword: {
    required: true,
    validator: {
      regEx: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,

      // value: true,
      errEmpty: "Confirm Password is a required field",
      error: "Password does not match.",
    },
  },
};

export const CompanyInfoValidate = {
  companyName: {
    required: true,
    validator: {
      regEx: isText,
      error: "Company Name must be in letters",

      errEmpty: "Company name is required",
    },
  },
  owner: {
    required: true,
    validator: {
      regEx: isText,
      error: "Owner Name must be in letters",

      errEmpty: "Owner name is required",
    },
  },
  email: {
    required: true,
    validator: {
      regEx: isEmail,
      error: "Please enter a valid email",
      errEmpty: "Email is Required",
    },
  },

  city: {
    required: true,
    validator: {
      regEx: isText,
      error: "City Name must be in letters",

      errEmpty: "City name is required",
    },
  },
  states: {
    required: true,
    validator: {
      regEx: isText,
      error: "State Name must be in letters",

      errEmpty: "State name is required",
    },
  },
  zipCode: {
    required: true,
    validator: {
      regEx: /^\d+$/,
      error: "ZipCode must be in numbers",
      errEmpty: "Zipcode is required",
    },
  },
  country: {
    required: true,
    validator: {
      regEx: isText,
      // value: true,
      errEmpty: "Country name is required",
    },
  },

  industry: {
    required: true,
    validator: {
      regEx: isText,
      // value: true,
      errEmpty: "Industry is required",
    },
  },
};

export const AccountSettingsValidate = {
  companyName: {
    required: true,
    validator: {
      regEx: isText,
      error: "Company name must contain only letters",
      errEmpty: "Company name is required",
    },
  },
  email: {
    required: true,
    validator: {
      regEx: isEmail,
      error: "Please enter a valid email",
      errEmpty: "Email is required",
    },
  },
  phone: {
    required: false,
    validator: {
      mobileValidate: {
        regEx: isPhone,
        error: "Entered value should be between 8-15",
      },
    },
  },
  addressLine1: {
    required: true,
    validator: {
      regEx: isParagraph,
      // error: "AddressLine1 name is required",
      errEmpty: "AddressLine1 is required",
    },
  },
  addressLine2: {
    required: true,
    validator: {
      regEx: isParagraph,
      errEmpty: "AddressLine2 name is required",
    },
  },

  city: {
    required: true,
    validator: {
      regEx: isText,
      errEmpty: "City name is required",
    },
  },
  states: {
    required: true,
    validator: {
      regEx: isText,
      errEmpty: "State name is required",
    },
  },
  zipCode: {
    required: true,
    validator: {
      regEx: /^\d+$/,
      // value: true,
      errEmpty: "Zipcode is required",
    },
  },
  country: {
    required: true,
    validator: {
      regEx: isText,
      // value: true,
      errEmpty: "Country is required",
    },
  },
  region: {
    required: true,
    validator: {
      regEx: isText,
      errEmpty: "Region is required",
    },
  },
  companyRegistrationNumber: {
    required: true,
    validator: {
      regEx: isParagraph,
      // value: true,
      errEmpty: "Company Registration Number is required",
    },
  },
  cellNumber: {
    required: true,
    validator: {
      mobileValidate: {
        regEx: isPhone,
        error: "Entered text should be between 8-15",
      },
      errEmpty: "Mobile Number is a required field",
    },
  },
  incomeTax: {
    required: true,
    validator: {
      regEx: isTaxNumber,
      error: TAX_NUMBER_ERROR,
      // value: true,
      errEmpty: "Income Tax Number is required",
    },
  },

  number: {
    required: false,
    validator: {
      regEx: isTaxNumber,
      error: TAX_NUMBER_ERROR,
      // value: true,
      errEmpty: "Number is required",
    },
  },

  currency: {
    required: true,
    validator: {
      regEx: isText,
      // value: true,
      errEmpty: "Currency is required",
    },
    logo: {
      required: false, // Assuming this is optional
      validator: {
        regEx: /\.(jpg|jpeg|png|gif)$/,
        error: "Please upload a valid image file (jpg, jpeg, png, gif)",
      },
    },
    favicon: {
      required: false, // Assuming this is optional
      validator: {
        regEx: /\.(jpg|jpeg|png|gif)$/,
        error: "Please upload a valid image file (jpg, jpeg, png, gif)",
      },
    },

    addLeaveType: {
      required: true,
      validator: {
        regEx: isText,
        // value: true,
        errEmpty: "LeaveType is required",
      },
    },
  },
};

export const ItemsValidates = {
  itemTitle: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9][A-Za-z0-9\s]{0,50}$/,
      errEmpty: "Item Title is required",
      error: "Enter Valid Item Name"
    },
  },
  commission: {
    required: true,
    validator: {
      regEx: /^(0|[1-9]\d*)(\.\d+)?$/,
      min: 0,
      error: "Commission should be a positive number",
    }
  },
  contributionCompany: {
    required: true,
    validator: {
      regEx: /^(0|[1-9]\d*)(\.\d+)?$/,
      min: 0,
      error: "Commission should be a positive number",
    }
  },
  description: {
    required: false,
    validator: {
      regEx: /^(?!\s)(.|\s){1,250}$/,
      errEmpty: "Description is required",
      error: "Enter valid description"
    },
  },
  sku: {
    required: false,
    validator: {
      mobileValidate: {
        regEx: /^[A-Za-z0-9][A-Za-z0-9\s]{0,30}$/,
        errEmpty: "SKU is a required field",
      },
    },
  },
  barcodeType: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9]{1,21}$/,
      error: "Enter Valid BarCode",
      errEmpty: "Barcode name is required",
    },
  },
  category: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9][A-Za-z0-9\s]{0,50}$/,
      errEmpty: "Category name is required",
      error: "Enter Valid Category"
    },
  },
  subCategory: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9][A-Za-z0-9\s]{0,50}$/,
      // value: true,
      errEmpty: "Sub Category is required",
      error: "enter Valid Sub-Category"
    },
  },
  bussinessLocation: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9][A-Za-z0-9\s]{0,50}$/,
      // value: true,
      errEmpty: "Bussiness Location is required",
      error: "Enter Valid Business Location"
    },
  },
  manageStock: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9][A-Za-z0-9\s]{0,30}$/,
      // value: true,
      errEmpty: "Manage Stock is required",
      error: "Enter Valid Manage Stock"
    },
  },
  quantity: {
    required: false,
    validator: {
      regEx: /^\d{1,10}$/,
      // value: true,
      errEmpty: "Alert Quantity is required",
      error: "Enter Valid Alert Quantity"

    },
  },
  weight: {
    required: false,
    validator: {
      regEx: /^\d+(\.\d+)?$/,
      // value: true,
      errEmpty: "Weight is required",
      error: "Enter Valid Weight"
    },
  },
  purchasePrice: {
    required: true,
    validator: {
      regEx: /^(0|[1-9]\d*)(\.\d+)?$/,
      min: 0,
      errEmpty: "Purchase Price is required",
    },
  },
  sellingPrice: {
    required: true,
    validator: {
      regEx: /^(0|[1-9]\d*)(\.\d+)?$/,
      min: 0,
      errEmpty: "Selling Price is required",
    },
  },
  stockQuantity: {
    required: true,
    validator: {
      regEx: /^[1-9]\d*$/,
      min: 0,
      errEmpty: "Quantity is required",
    },
  },
  tax: {
    required: true,
    validator: {
      regEx: /^\d+(\.\d+)?$/,
      min: 0,
      max: 100,
      errEmpty: "Tax is required",
      minError: "Value cannot be less than 0",
      maxError: "Value cannot be more than 100"
    },
  },
  discount: {
    required: false,
    validator: {
      regEx: /^\d+(\.\d+)?$/,
      min: 0,
      max: 100,
      errEmpty: "Discount is required",
      minError: "Value cannot be less than 0",
      maxError: "Value cannot be more than 100",
    }
  }
};
export const createBankValidation = {
  bankName: {
    required: true,
    validator: {
      regEx: /^(?!\s)[A-Za-z\s]{1,50}$/,
      error: "Enter Valid Bank Name",
      errEmpty: "Bank Name is required",
    },
  },
  branch: {
    required: true,
    validator: {
      regEx: /^(?!\s)[A-Za-z0-9\s]{1,50}$/,
      error: "Branch must contain only letters",
      errEmpty: "Enter Valid Branch Name",
    },
  },
  accountHolder: {
    required: true,
    validator: {
      regEx: /^(?!\s)[A-Za-z\s]{1,50}$/,
      error: "Please enter valid Account Holder",
      errEmpty: "Account Holder is required",
    },
  },
  accountNumber: {
    required: true,
    validator: {
      regEx: /^[0-9]{8,20}$/,
      error: "Should have 8-20 digits",
      errEmpty: "Account Number is required",
    },
  },

  mobile: {
    required: false,
    validator: {
      regEx: isPhone,
      error: "Mobile number must be in digits",
      errEmpty: "Mobile is required",
    },
  },
  initialBalance: {
    required: true,
    validator: {
      regEx: /^\d+(\.\d+)?$/,
      error: "Please enter valid Account Balance",
      errEmpty: "Initial Balance is required",
    },
  },
  internetBanking: {
    required: false,
    validator: {
      regEx: isText,
      error: "Please enter valid Internet Banking url",
      errEmpty: "Sub Category is required",
    },
  },
  swiftCode: {
    required: true,
    validator: {
      regEx: /^(?:[A-Z0-9]{8}|[A-Z0-9]{11})$/,
      error: "Swift Code must be 8 or 11 characters long, uppercase alphanumeric only",
      errEmpty: "Swift Code is required",
    },
  }
};
export const addBankValidation = {
  accountName: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9&.\-\s]{3,100}$/,
      error: "Account Name must be 3–100 characters and may include letters, numbers, spaces, &, ., -",
      errEmpty: "Account Name is required",
    },
  },
  accountCode: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9]{2,20}$/,
      error: "Account Code must be 2–20 alphanumeric characters",
      errEmpty: "Account Code is required",
    },
  },
  currency: {
    required: true,
    validator: {
      regEx: /^[A-Z]{3}$/,
      error: "Currency must be a valid 3-letter ISO code (e.g., USD, INR, EUR)",
      errEmpty: "Currency is required",
    },
  },
  accountNumber: {
    required: true,
    validator: {
      regEx: isPhone,
      error: "Account Number must be 9–18 digits",
      errEmpty: "Account Number is required",
    },
  },
  bankName: {
    required: true,
    validator: {
      regEx: /^[A-Za-z\s]{3,100}$/,
      error: "Bank Name must be 3–100 characters and contain only letters and spaces",
      errEmpty: "Bank Name is required",
    },
  },
  ifsc: {
    required: true,
    validator: {
      regEx: /^[A-Z]{4}0\d{6}$/,
      error: "IFSC Code must be in the format: 4 letters, 0, and 6 digits (e.g., SBIN0001234)",
      errEmpty: "IFSC Code is required",
    },
  },
  description: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9\s.,!@#$%^&*()\-+=:;'"?<>\/\\|[\]{}]{0,250}$/,
      error: "Description can be up to 250 characters (letters, numbers, spaces, punctuation allowed)",
      errEmpty: "Description is required",
    },
  },
  makePrimary: {
    required: false, // optional, but only one can be true in system logic
    validator: {
      regEx: /^(true|false)?$/,
      error: "Primary Account must be true or false",
      errEmpty: "",
    },
  },
};


export const AddExpenseValidation = {
  name: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9\s\-\.,&]{3,100}$/, // Alphabets, numbers, spaces, -, ., &
      error: "Name must be 3–100 characters; only letters, numbers, spaces, - , . & allowed",
      errEmpty: "Name is required",
    },
  },
  type: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9\s]{1,50}$/, // Selected from predefined list
      error: "Invalid Expense Type",
      errEmpty: "Expense Type is required",
    },
  },
  amount: {
    required: true,
    validator: {
      regEx: /^(?:[1-9]\d*|0)?(?:\.\d{1,2})?$/,
      error: "Amount must be a positive number with max 2 decimal places",
      errEmpty: "Amount is required",
    },
  },
  taxAmount: {
    required: false,
    validator: {
      regEx: /^(?:[1-9]\d*|0)?(?:\.\d{1,2})?$/, // Positive number, max 2 decimals
      custom: (value, allValues) => {
        if (!value) return true; // optional
        return Number(value) <= Number(allValues.amount?.value || 0);
      },
      error: "Tax Amount cannot exceed Amount",
      errEmpty: "Tax Amount is required",
    },
  },
  date: {
    required: true,
    validator: {
      custom: (value) => {
        if (!value) return false;
        const inputDate = new Date(value);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return inputDate <= today;
      },
      error: "Date cannot be a future date",
      errEmpty: "Date is required",
    },
  },
  paymentMethod: {
    required: true,
    validator: {
      regEx: /^(Cash|Bank|Card|UPI)$/, // Must match these options
      error: "Invalid Payment Method",
      errEmpty: "Payment Method is required",
    },
  },
  bank: {
    required: false,
    validator: {
      custom: (value, allValues) => {
        if (allValues.paymentMethod?.value === "Bank") {
          return !!value; // Bank must be selected if Payment Method is Bank
        }
        return true; // optional otherwise
      },
      error: "Bank must be selected for Bank Payment Method",
      errEmpty: "Bank is required",
    },
  },
  description: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9\s.,!@#$%^&*()_+\-=[\]{};':"\\|<>/?]{0,500}$/, // Max 500 chars, letters, numbers, spaces, punctuation
      error: "Description cannot exceed 500 characters",
      errEmpty: "Description is required",
    },
  },
  uploadFile: {
    required: false,
    validator: {
      custom: (files) => {
        if (!files || files.length === 0) return true;
        const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
        return files.every(file => allowedTypes.includes(file.type) && file.size <= 5 * 1024 * 1024);
      },
      error: "Invalid file. Allowed: PDF, JPG, PNG, DOCX; max size 5 MB",
      errEmpty: "",
    },
  },
};

export const addNewUserValidation = {
  name: {
    required: true,
    validator: {
      regEx: /^(?!\s)[A-Za-z\s]{1,50}$/,
      error: "Enter Valid Name",
      errEmpty: "Name is required",
    },
  },
  mobile: {
    required: true,
    validator: {
      regEx: isPhone,
      error: "Mobile number must be in digits",
      errEmpty: "Mobile is required",
    },
  },
  email: {
    required: true,
    validator: {
      regEx: isEmail,
      error: "Invalid email format.",
      errEmpty: "Email is a required field",
    },
  },
  address: {
    required: false,
    validator: {
      regEx: /^(?!\s)[A-Za-z0-9\s,.#-]{1,150}$/,
      error: "Please provide a valid Address ",
      errEmpty: "Address is a required field",
    },
  },
  city: {
    required: true,
    validator: {
      regEx: /^(?!\s)[A-Za-z\s]{1,50}$/,
      error: "Please Provide a Valid City Name",
      errEmpty: "City is a required field",
    },
  },
  country: {
    required: true,
    validator: {
      regEx: /^[a-zA-Z\s]+$/,
      error: "Country must contain only letters and spaces",
      errEmpty: "Country is a required field",
    },
  },

  zipCode: {
    required: true,
    validator: {
      regEx: /^\d{6}$/,
      min: 0,
      error: "Zip code must be 6 digit number",
      errEmpty: "Zip Code is a required field",
    },
  }
}
// utils/Validation.js or wherever your validation is
export const addNewCustomerValidation = {
  name: {
    required: true,
    validator: {
      regEx: /^[A-Za-z\s]{3,100}$/, // Alphabets & spaces, 3-100 chars
      error: "Name must be 3-100 letters & spaces only",
      errEmpty: "Name is required",
    },
  },
  companyName: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9\s]{3,100}$/, // Alphabets, numbers, spaces, 3-100 chars
      error: "Company Name must be 3-100 characters; letters, numbers & spaces only",
      errEmpty: "",
    },
  },
  email: {
    required: true,
    validator: {
      regEx: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, // simple email regex
      error: "Enter a valid email (max 100 chars)",
      errEmpty: "Email is required",
    },
  },
  phone: {
    required: true,
    validator: {
      regEx: /^\+\d{1,4}\s\d{10,15}$/, // +CountryCode Number, 10-15 digits
      error: "Phone must be in format +CountryCode Number (10-15 digits)",
      errEmpty: "Phone is required",
    },
  },
  taxId: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9]{5,20}$/, // Alphanumeric, 5-20 chars
      error: "Enter valid Tax ID / VAT",
      errEmpty: "",
    },
  },
  creditLimits: {
    required: false,
    validator: {
      regEx: /^\d+(\.\d{1,2})?$/, // Positive number, max 2 decimals
      error: "Credit Limits must be a number with max 2 decimals",
      errEmpty: "",
    },
  },
  customerBlock: {
    required: false,
    validator: {
      regEx: /^(Yes|No)$/i, // Boolean Yes/No
      error: "Value must be Yes or No",
      errEmpty: "",
    },
  },
  // Billing address
  country: {
    required: false,
    validator: {
      regEx: /^[A-Za-z\s]+$/, // Assuming selection from dropdown, simple regex
      error: "Select a valid country",
      errEmpty: "Country is required",
    },
  },
  street1: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9\s,]{5,100}$/, // Letters, numbers, spaces, comma, 5-100 chars
      error: "Street 1 must be 5-100 characters; letters, numbers, comma allowed",
      errEmpty: "Street 1 is required",
    },
  },
  street2: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9\s,]{5,100}$/,
      error: "Street 2 must be 5-100 characters; letters, numbers, comma allowed",
      errEmpty: "",
    },
  },
  city: {
    required: true,
    validator: {
      regEx: /^[A-Za-z\s]{2,50}$/, // Alphabets & spaces, 2-50 chars
      error: "City must be 2-50 letters & spaces only",
      errEmpty: "City is required",
    },
  },
  city2: {
    required: true,
    validator: {
      regEx: /^[A-Za-z\s]{2,50}$/, // Alphabets & spaces, 2-50 chars
      error: "City must be 2-50 letters & spaces only",
      errEmpty: "City is required",
    },
  },
  state1: {
    required: true,
    validator: {
      regEx: /^[A-Za-z\s]{2,50}$/, // Alphabets & spaces, 2-50 chars
      error: "State must be 2-50 letters & spaces only",
      errEmpty: "State is required",
    },
  },
  state2: {
    required: true,
    validator: {
      regEx: /^[A-Za-z\s]{2,50}$/, // Alphabets & spaces, 2-50 chars
      error: "State must be 2-50 letters & spaces only",
      errEmpty: "State is required",
    },
  },
  pinCode: {
    required: true,
    validator: {
      regEx: /^\d{5,10}$/, // Numeric, 5-10 digits
      error: "Pin Code must be 5-10 digits",
      errEmpty: "Pin Code is required",
    },
  },
  pinCode1: {
    required: true,
    validator: {
      regEx: /^\d{5,10}$/, // Numeric, 5-10 digits
      error: "Pin Code must be 5-10 digits",
      errEmpty: "Pin Code is required",
    },
  },
  addressPhone: {
    required: false,
    validator: {
      regEx: /^\+\d{1,4}\s\d{10,15}$/, // Optional phone for address
      error: "Phone must be in format +CountryCode Number (10-15 digits)",
      errEmpty: "",
    },
  },
};

export const addNewSupplierValidation = {
  name: {
    required: true,
    validator: {
      regEx: /^(?!\s)[A-Za-z\s]{1,100}$/,
      error: "must be less than 100 chars only & only letters",
      errEmpty: "Name is required",
    },
  },
  phone: {
    required: true,
    validator: {
      regEx: isPhone,
      error: "Mobile number must be in digits",
      errEmpty: "Mobile is required",
    },
  },
  email: {
    required: true,
    validator: {
      regEx: isEmail,
      error: "Invalid email format.",
      errEmpty: "Email is a required field",
    },
  },
  creditLimits: {
    required: false,
    validator: {
      regEx: /^\d+(\.\d+)?$/,
      error: "Credit Limits must be a number",
      errEmpty: "Credit Limits is required",
    },
  },
};

export const addInvoiceValidation = (data, invoiceType) => {
  const errors = {};

  // 🔹 Helper function
  const isEmpty = (val) => !val || !val.toString().trim();

  // -------------------
  // Common validations
  if (isEmpty(data.street1?.value)) {
    errors.street1 = "Street is required";
  }
  if (isEmpty(data.customer?.value)) {
    errors.customer = "Customer is required";
  }
  if (isEmpty(data.invoiceDate?.value)) {
    errors.invoiceDate = "Invoice date is required";
  }
  // -------------------
  if (isEmpty(data.invNumber?.value)) {
    errors.invNumber = "Invoice number is required";
  }

  if (isEmpty(data.cName?.value)) {
    errors.cName = "Customer name is required";
  }

  if (isEmpty(data.emailAddress?.value)) {
    errors.emailAddress = "Email address is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.emailAddress.value)) {
    errors.emailAddress = "Invalid email address";
  }

  if (isEmpty(data.clientAddress?.value)) {
    errors.clientAddress = "Client address is required";
  }

  if (isEmpty(data.billingAddress?.value)) {
    errors.billingAddress = "Billing address is required";
  }

  // -------------------
  // Recurring Invoice
  // -------------------
  if (invoiceType === "Recurring Invoice") {
    if (isEmpty(data.profileName?.value)) {
      errors.profileName = "Profile name is required";
    }

    if (isEmpty(data.repeatEvery?.value)) {
      errors.repeatEvery = "Repeat frequency is required";
    }

    if (!data.startDate?.value) {
      errors.startDate = "Start date is required";
    }

    if (!data.endDate?.value) {
      errors.endDate = "End date is required";
    }

    if (isEmpty(data.dailyPenaltyAmount?.value)) {
      errors.dailyPenaltyAmount = "Daily penalty amount is required";
    } else if (isNaN(data.dailyPenaltyAmount.value) || Number(data.dailyPenaltyAmount.value) < 0) {
      errors.dailyPenaltyAmount = "Invalid penalty amount";
    }
  }
  // -------------------
  // One-Time Invoice
  // -------------------
  else if (invoiceType === "One-Time Invoice") {
    if (!data.invoiceDate?.value) {
      errors.invoiceDate = "Invoice date is required";
    }

    if (!data.dueDate?.value) {
      errors.dueDate = "Due date is required";
    }
  }

  // -------------------
  // Common field
  // -------------------
  if (isEmpty(data.paymentTerms?.value)) {
    errors.paymentTerms = "Payment terms is required";
  }

  // -------------------
  // Product validation
  // -------------------
  if (!data.products || data.products.length === 0) {
    errors.products = "At least one product is required";
  } else {
    data.products.forEach((product, index) => {
      if (isEmpty(product.name)) {
        errors[`products[${index}].name`] = "Product name is required";
      }
      if (!product.quantity || product.quantity <= 0) {
        errors[`products[${index}].quantity`] = "Valid quantity is required";
      }
      if (!product.amount || product.amount <= 0) {
        errors[`products[${index}].amount`] = "Valid amount is required";
      }
    });
  }

  return errors;
};

export const editInvoiceValidation = {
  invName: {
    required: true,
    validator: {
      regEx: isText,
      errEmpty: "Invoive Number is required",
    },
  },

  project: {
    required: false,
    validator: {
      // error: "AddressLine1 name is required",
      errEmpty: "Project is required",
    },
  },
  emailAddress: {
    required: true,
    validator: {
      regEx: isEmail,
      error: "Invalid email format.",
      errEmpty: "Email is a required field",
    },
  },

  phone: {
    required: true,
    validator: {
      regEx: isPhone,
      error: "Mobile number must be in digits",
      errEmpty: "Mobile Number is required",
    },
  },
  clientAddress: {
    required: true,
    validator: {
      regEx: isText,
      errEmpty: "Client Address is required",
    },
  },
  billingAddress: {
    required: true,
    validator: {
      regEx: isText,
      // value: true,
      errEmpty: "Billing Address is required",
    },
  },
  tax: {
    required: false,
    validator: {
      regEx: isNumber,
      // value: true,
      errEmpty: "Tax is required",
    },
  },
  discount: {
    required: false,
    validator: {
      regEx: isNumber,
      // value: true,
      errEmpty: "Discount is required",
    },
  },
};
export const addBillValidation = {
  supplier: {
    requiresd: true,
    validator: {
      regEx: isText,
      errEmpty: "Supplier is required",
    },
  },
  billDate: {
    required: true,
    validator: {
      errEmpty: "Bill Date is required",
    },
  },
  dueDate: {
    required: true,
    validator: {
      errEmpty: "Due Date is a required field",
    },
  },
  billNumber: {
    required: true,
    validator: {
      // error: "AddressLine1 name is required",
      errEmpty: "Bill Number is required",
    },
  },
  Category: {
    required: true,
    validator: {
      errEmpty: "Category is a required field",
    },
  },

  orderNumber: {
    required: true,
    validator: {
      errEmpty: "Order Number is required",
    },
  },
  tax: {
    required: true,
    validator: {
      regEx: isNumber,
      // value: true,
      errEmpty: "Tax is required",
    },
  },
  discount: {
    required: true,
    validator: {
      regEx: isText,
      // value: true,
      errEmpty: "Discount is required",
    },
  },
  productName: {
    required: false,
    validator: {
      regEx: isText,
      // value: true,
      errEmpty: "Product Name is required",
    },
  },
  description: {
    required: false,
    validator: {
      regEx: isText,
      // value: true,
      errEmpty: "Description is required",
    },
  },

  unitCost: {
    required: false,
    validator: {
      regEx: isPhone,
      // value: true,
      errEmpty: "unitCost is required",
    },
    qty: {
      required: false,
      validator: {
        regEx: isPhone,
        // value: true,
        errEmpty: "QTY is required",
      },
    },
    amount: {
      required: false,
      validator: {
        regEx: isPhone,
        // value: true,
        errEmpty: "Amount is required",
      },
    },
  },
};


export const validateField = (fieldName, value, formData) => {
  const errors = {};

  switch (fieldName) {
    case 'customerId':
      if (!value) errors.customerId = 'Customer is required';
      break;
    case 'creditNoteNumber':
      if (!value) errors.creditNoteNumber = 'Credit Note Number is required';
      break;
    case 'creditNoteDate':
      if (!value) errors.creditNoteDate = 'Credit Note Date is required';
      break;
    case 'salesperson':
      if (!value) errors.salesperson = 'Salesperson is required';
      break;
    case 'subject':
      if (!value) errors.subject = 'Subject is required';
      break;
    case 'customerNotes':
      if (!value || value.trim() === '') errors.customerNotes = 'Customer Notes are required';
      break;
    case 'items':
      if (!value || value.length === 0) {
        errors.items = 'At least one item is required';
      } else {
        value.forEach((item, index) => {
          if (!item.name) errors[`items[${index}].name`] = 'Item name is required';
          if (!item.quantity || item.quantity <= 0) errors[`items[${index}].quantity`] = 'Valid quantity is required';
          if (!item.rate || item.rate <= 0) errors[`items[${index}].rate`] = 'Valid rate is required';
        });
      }
      break;
    case 'discountPercentage':
      if (value === '' || isNaN(value)) errors.discountPercentage = 'Discount must be a number';
      break;
    case 'taxPercentage':
      if (value === '' || isNaN(value)) errors.taxPercentage = 'Tax must be a number';
      break;
    default:
      break;
  }

  return errors;
};

export const validateForm = (formData) => {
  let errors = {};

  // Validate all fields
  errors = {
    ...errors,
    ...validateField('customerId', formData.customerId, formData),
    ...validateField('creditNoteNumber', formData.creditNoteNumber, formData),
    ...validateField('creditNoteDate', formData.creditNoteDate, formData),
    ...validateField('salesperson', formData.salesperson, formData),
    ...validateField('subject', formData.subject, formData),
    ...validateField('customerNotes', formData.customerNotes, formData),
    ...validateField('items', formData.items, formData),
    ...validateField('discountPercentage', formData.discountPercentage, formData),
    ...validateField('taxPercentage', formData.taxPercentage, formData),
  };

  return errors;
};

export const CreateSupplierValidation = {
  name: {
    required: true,
    validator: {
      regEx: /^[A-Za-z\s]{3,100}$/,
      error: "Name must be 3-100 characters (alphabets and spaces only)",
      errEmpty: "Name is required",
    },
  },
  email: {
    required: true,
    validator: {
      regEx: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      error: "Invalid email format (e.g., abc@domain.com)",
      errEmpty: "Email is required",
    },
  },
  phone: {
    required: true,
    validator: {
      regEx: /^\+\d{10,15}$/,
      error: "Phone must be in format +CountryCode Number (10-15 digits)",
      errEmpty: "Phone is required",
    },
  },
  creditLimits: {
    required: false,
    validator: {
      regEx: /^\d+(\.\d{1,2})?$/,
      error: "Credit Limits must be a positive number with max 2 decimal places",
      errEmpty: "",
    },
  },
  country: {
    required: true,
    validator: {
      regEx: /.+/,
      error: "Country/Region is required",
      errEmpty: "Country/Region is required",
    },
  },
  street1: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9,\s]{5,100}$/,
      error: "Address must be 5-100 characters (letters, numbers, spaces, comma allowed)",
      errEmpty: "Address is required",
    },
  },
  street2: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9,\s]{0,100}$/,
      error: "Address must be max 100 characters (letters, numbers, spaces, comma allowed)",
      errEmpty: "",
    },
  },
  city: {
    required: true,
    validator: {
      regEx: /^[A-Za-z\s]{2,50}$/,
      error: "City must be 2-50 characters (alphabets and spaces only)",
      errEmpty: "City is required",
    },
  },
  state: {
    required: true,
    validator: {
      regEx: /^[A-Za-z\s]{2,50}$/,
      error: "State must be 2-50 characters (alphabets and spaces only)",
      errEmpty: "State is required",
    },
  },
  pinCode: {
    required: true,
    validator: {
      regEx: /^\d{5,10}$/,
      error: "Pin Code must be 5-10 digits",
      errEmpty: "Pin Code is required",
    },
  },
  addressPhone: {
    required: false,
    validator: {
      regEx: /^(\+\d{10,15})?$/,
      error: "Phone must be in format +CountryCode Number (10-15 digits)",
      errEmpty: "",
    },
  },
};

export const QuoteValidation = {
  customer: {
    required: true,
    validator: {
      regEx: /^.+$/,
      error: "Customer must be selected",
      errEmpty: "Customer is required",
    },
  },
  quoteNumber: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9-]+$/,
      error: "Quote number must be alphanumeric",
      errEmpty: "Quote number is required",
    },
  },
  referenceNumber: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9]{0,50}$/,
      error: "Alphanumeric only; max 50 characters",
      errEmpty: "",
    },
  },
  quoteDate: {
    required: true,
    validator: {
      regEx: /^.+$/,
      error: "Quote date is required",
      errEmpty: "Quote date is required",
    },
  },
  expiryDate: {
    required: true,
    validator: {
      regEx: /^.+$/,
      error: "Expiry date must be after quote date",
      errEmpty: "Expiry date is required",
    },
  },
  salesperson: {
    required: false,
    validator: {
      regEx: /^.{0,100}$/,
      error: "",
      errEmpty: "",
    },
  },
  subject: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9\s.,!?]{0,100}$/,
      error: "Min 5 and Max 100 characters; no special characters",
      errEmpty: "",
    },
  },
  item: {
    required: true,
    validator: {
      regEx: /^.+$/,
      error: "Item must be selected",
      errEmpty: "Item is required",
    },
  },
  description: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9\s,-]{0,250}$/,
      error: "Min 5 and Max 250 characters; alphabets, numbers, commas, hyphens only",
      errEmpty: "",
    },
  },
  quantity: {
    required: true,
    validator: {
      regEx: /^[1-9][0-9]{0,3}$/,
      error: "Numeric only; must be > 0; max 4 digits",
      errEmpty: "Quantity is required",
    },
  },
  rate: {
    required: true,
    validator: {
      regEx: /^\d+(\.\d{1,2})?$/,
      error: "Numeric only; must be ≥ 0.01; up to 2 decimal places",
      errEmpty: "Rate is required",
    },
  },
  discount: {
    required: false,
    validator: {
      regEx: /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{1,2})?)$/,
      error: "Percentage only; between 0 and 100",
      errEmpty: "",
    },
  },
  customerNotes: {
    required: false,
    validator: {
      regEx: /^[\s\S]{0,500}$/,
      error: "Max 500 characters",
      errEmpty: "",
    },
  },
  termsAndConditions: {
    required: false,
    validator: {
      regEx: /^[\s\S]{0,1000}$/,
      error: "Max 1000 characters",
      errEmpty: "",
    },
  },
  tax: {
    required: false,
    validator: {
      regEx: /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{1,2})?)$/,
      error: "Percentage only; between 0 and 100",
      errEmpty: "",
    },
  },
  adjustment: {
    required: false,
    validator: {
      regEx: /^-?\d{1,5}(\.\d{1,2})?$/,
      error: "Can be positive or negative; numeric only; max ±99999",
      errEmpty: "",
    },
  },
  tdsTcs: {
    required: true,
    validator: {
      regEx: /^(TDS|TCS)$/,
      error: "Must select TDS or TCS",
      errEmpty: "TDS/TCS selection is required",
    },
  },
};

export const CreditNoteValidation = {
  customer: {
    required: true,
    validator: {
      regEx: /^.+$/,
      error: "Customer must be selected",
      errEmpty: "Customer is required",
    },
  },
  creditNoteNumber: {
    required: true,
    validator: {
      regEx: /^[A-Za-z0-9-]{5,20}$/,
      error: "Alphanumeric; 5-20 characters",
      errEmpty: "Credit Note number is required",
    },
  },
  creditNoteDate: {
    required: true,
    validator: {
      regEx: /^.+$/,
      error: "Date cannot be in future",
      errEmpty: "Credit Note date is required",
    },
  },
  salesperson: {
    required: false,
    validator: {
      regEx: /^.{0,100}$/,
      error: "",
      errEmpty: "",
    },
  },
  subject: {
    required: false,
    validator: {
      regEx: /^[A-Za-z0-9\s]{0,100}$/,
      error: "Max 100 characters; alphabets, numbers, spaces allowed",
      errEmpty: "",
    },
  },
  customerNotes: {
    required: false,
    validator: {
      regEx: /^[\s\S]{0,500}$/,
      error: "Max 500 characters; letters, numbers, punctuation allowed",
      errEmpty: "",
    },
  },
  item: {
    required: true,
    validator: {
      regEx: /^.+$/,
      error: "Item must be selected",
      errEmpty: "Item is required",
    },
  },
  account: {
    required: true,
    validator: {
      regEx: /^.+$/,
      error: "Account must be selected",
      errEmpty: "Account is required",
    },
  },
  quantity: {
    required: true,
    validator: {
      regEx: /^[1-9]\d*$/,
      error: "Positive numeric; min 1; no negative values",
      errEmpty: "Quantity is required",
    },
  },
  rate: {
    required: true,
    validator: {
      regEx: /^\d+(\.\d{1,2})?$/,
      error: "Numeric; must be ≥ 0.01",
      errEmpty: "Rate is required",
    },
  },
  discount: {
    required: false,
    validator: {
      regEx: /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{1,2})?)$/,
      error: "Percentage only; between 0 and 100",
      errEmpty: "",
    },
  },
  tax: {
    required: false,
    validator: {
      regEx: /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{1,2})?)$/,
      error: "Percentage only; between 0 and 100",
      errEmpty: "",
    },
  },
};

export const CreateSalesOrderValidation = {
  // Customer Details
  customerName: {
    required: true,
    error: "Please select a customer from the list"
  },

  // Sales Order #
  salesOrderNumber: {
    required: true,
    pattern: /^[a-zA-Z0-9]{5,20}$/,
    error: "Sales Order # must be alphanumeric and 5-20 characters long"
  },

  // Sales Order Date
  salesOrderDate: {
    required: true,
    validate: (value) => {
      if (!value) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const inputDate = value.$d ? new Date(value.$d) : new Date(value); // ✅ works with Dayjs or Date
      return inputDate <= today;
    },
    error: "Format: MM/DD/YYYY; cannot be a future date"
  },

  // Expected Shipment Date
  expectedShipmentDate: {
    required: true,
    validate: (value, { salesOrderDate }) => {
      if (!value || !salesOrderDate) return false;

      const soDate = salesOrderDate.$d ? new Date(salesOrderDate.$d) : new Date(salesOrderDate);
      const shipDate = value.$d ? new Date(value.$d) : new Date(value);

      return shipDate >= soDate;
    },
    error: "Format: MM/DD/YYYY; must be ≥ Sales Order Date"
  },

  // Payment Terms
  paymentTerms: {
    required: true,
    error: "Please select payment terms"
  },

  // Delivery Method (optional)
  deliveryMethod: {
    required: false,
    error: "Please select a valid delivery method"
  },

  // Subject
  subject: {
    required: false,
    maxLength: 100,
    pattern: /^[A-Za-z0-9\s]+$/,
    error: "Subject can contain letters, numbers, and spaces (max 100 chars)"
  },

  // Customer Notes
  customerNotes: {
    required: false,
    maxLength: 500,
    error: "Customer Notes cannot exceed 500 characters"
  },

  // Item Name
  itemName: {
    required: true,
    error: "Please select an item from the product/service list"
  },

  // Description
  description: {
    required: false,
    maxLength: 500,
    error: "Description cannot exceed 500 characters"
  },

  // Quantity
  quantity: {
    required: true,
    pattern: /^[1-9]\d*$/,
    error: "Quantity must be a positive number (min 1)"
  },

  // Unit Price
  unitPrice: {
    required: true,
    pattern: /^\d+(\.\d{1,2})?$/,
    error: "Unit Price must be a positive number with max 2 decimals"
  },

  // Discount (%)
  discount: {
    required: false,
    pattern: /^(100|\d{1,2}(\.\d{1,2})?)$/,
    error: "Discount must be between 0–100"
  },

  // Tax (%)
  tax: {
    required: false,
    pattern: /^(100|\d{1,2}(\.\d{1,2})?)$/,
    error: "Tax must be between 0–100"
  },

  // Terms & Conditions
  termsAndConditions: {
    required: false,
    maxLength: 1000,
    error: "Terms & Conditions cannot exceed 1000 characters"
  },

  // Attach File
  file: {
    required: false,
    validate: (file) => {
      if (!file) return true;
      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ];
      const isValidType = allowedTypes.includes(file.type);
      const isValidSize = file.size <= 5 * 1024 * 1024; // 5 MB
      return isValidType && isValidSize;
    },
    error: "Only PDF, JPG, PNG, or DOCX files allowed (max 5 MB)"
  }
};


export const CreateInventoryValidation = {
  title: {
    required: true,
    validator: {
      regEx: /^.{1,100}$/,
      error: "Title must be between 1-100 characters",
      errEmpty: "Title is required"
    }
  },
  unit: {
    required: true,
    validator: {
      regEx: /.+/,
      error: "Unit is required",
      errEmpty: "Unit is required"
    }
  },
  category: {
    required: true,
    validator: {
      regEx: /.+/,
      error: "Category is required",
      errEmpty: "Category is required"
    }
  },
  SKU: {
    required: true,
    validator: {
      regEx: /^.{1,50}$/,
      error: "SKU must be between 1-50 characters",
      errEmpty: "SKU is required"
    }
  },
  sellingPrice: {
    required: true,
    validator: {
      regEx: /^\d+(\.\d{1,2})?$/,
      error: "Enter a valid price",
      errEmpty: "Selling price is required"
    }
  },
  costPrice: {
    required: true,
    validator: {
      regEx: /^\d+(\.\d{1,2})?$/,
      error: "Enter a valid price",
      errEmpty: "Cost price is required"
    }
  },
  account: {
    required: false,
    validator: {
      regEx: /^.{0,100}$/,
      error: "Account must be less than 100 characters",
      errEmpty: ""
    }
  },
  description: {
    required: false,
    validator: {
      regEx: /^.{0,500}$/,
      error: "Description must be less than 500 characters",
      errEmpty: ""
    }
  },
  preferredSupplier: {
    required: false,
    validator: {
      regEx: /.*/,
      error: "",
      errEmpty: ""
    }
  },
  quantity: {
    required: false,
    validator: {
      regEx: /^\d*$/,
      error: "Quantity must be a number",
      errEmpty: ""
    }
  }
};

export const AssetFormValidate = {
  assetName: {
    required: "Asset Name is required",
    maxLength: {
      value: 150,
      message: "Asset Name must be less than 150 characters",
    },
    validate: {
      validFormat: (value) =>
        /^[a-zA-Z0-9\s\-'_()/&@#.+]+$/.test(value) ||
        "Contains invalid characters. Only letters, numbers, spaces, and -_'()/&@#.+ are allowed.",
      noOnlyWhitespace: (value) =>
        value.trim().length > 0 || "Asset Name cannot be only spaces",
    },
  },
  assetNumber: {
    required: "Asset Number is required",
    maxLength: {
      value: 50,
      message: "Asset Number must be less than 50 characters",
    },
    validate: {
      noWhitespace: (value) =>
        !/\s/.test(value) || "Asset Number cannot contain spaces",
    },
  },
  purchaseValue: {
    required: "Purchase Value is required",
    validate: {
      isPositive: (value) =>
        (!isNaN(parseFloat(value)) && parseFloat(value) > 0) ||
        "Purchase Value must be a number greater than 0",
      maxDecimals: (value) =>
        !value ||
        /^\d+(\.\d{1,2})?$/.test(value) ||
        "Cannot have more than 2 decimal places",
    },
  },
  purchaseDate: {
    required: "Purchase Date is required",
    validate: {
      isValidDate: (value) => {
        const date = new Date(value);
        return !isNaN(date.getTime()) || "Please enter a valid date";
      },
      isNotFuture: (value) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const selectedDate = new Date(value);
        return selectedDate <= today || "Purchase Date cannot be in the future";
      },
    },
  },
  serialNumber: {
    maxLength: {
      value: 100,
      message: "Serial Number must be less than 100 characters",
    },
  },
  currentValue: {
    validate: {
      isNonNegative: (value) =>
        !value ||
        (!isNaN(parseFloat(value)) && parseFloat(value) >= 0) ||
        "Current Value must be a positive number or zero",
      doesNotExceedPurchase: (value, formValues) =>
        !value ||
        !formValues.purchaseValue ||
        parseFloat(value) <= parseFloat(formValues.purchaseValue) ||
        "Current Value cannot exceed the Purchase Value",
      maxDecimals: (value) =>
        !value ||
        /^\d+(\.\d{1,2})?$/.test(value) ||
        "Cannot have more than 2 decimal places",
    },
  },
  disposalValue: {
    validate: {
      isNonNegative: (value) =>
        !value ||
        (!isNaN(parseFloat(value)) && parseFloat(value) >= 0) ||
        "Disposal Value must be a positive number or zero",
      doesNotExceedCurrent: (value, formValues) =>
        !value ||
        !formValues.currentValue ||
        parseFloat(value) <= parseFloat(formValues.currentValue) ||
        "Disposal Value cannot exceed the Current Value",
      maxDecimals: (value) =>
        !value ||
        /^\d+(\.\d{1,2})?$/.test(value) ||
        "Cannot have more than 2 decimal places",
    },
  },
  assetType: {
    required: "Please select an Asset Type",
  },
  warrantyExpirationDate: {
    validate: {
      isValidDate: (value) => {
        if (!value) return true; // Optional field
        const date = new Date(value);
        return !isNaN(date.getTime()) || "Please enter a valid date";
      },
      isAfterPurchase: (value, formValues) => {
        if (!value || !formValues.purchaseDate) return true;
        const warrantyDate = new Date(value);
        const purchaseDate = new Date(formValues.purchaseDate);
        return (
          warrantyDate >= purchaseDate ||
          "Warranty Expiration must be on or after the Purchase Date"
        );
      },
    },
  },
  description: {
    maxLength: {
      value: 1000,
      message: "Description must be less than 1000 characters",
    },
  },
  depreciationMethod: {
    required: "Depreciation Method is required",
  },
  depreciationPercentage: {
    validate: {
      // Conditional requirement
      isRequiredIfNotStraightLine: (value, formValues) => {
        if (formValues.depreciationMethod !== "Straight Line" && !value) {
          return "Depreciation Percentage is required for this method";
        }
        return true;
      },
      isValidRange: (value, formValues) => {
        // Only validate if a value is provided and method is not Straight Line
        if (
          !value ||
          formValues.depreciationMethod === "Straight Line" ||
          isNaN(parseFloat(value))
        )
          return true;
        const numValue = parseFloat(value);
        return (
          (numValue >= 1 && numValue <= 100) ||
          "Percentage must be between 1 and 100"
        );
      },
    },
  },
  computationType: {
    required: "Computation Type is required",
  },
  depreciationFrequency: {
    required: "Depreciation Frequency is required",
  },
  depreciationStartDate: {
    required: "Depreciation Start Date is required",
    validate: {
      isValidDate: (value) => {
        const date = new Date(value);
        return !isNaN(date.getTime()) || "Please enter a valid date";
      },
      isAfterPurchase: (value, formValues) => {
        if (!formValues.purchaseDate) return true;
        const startDate = new Date(value);
        const purchaseDate = new Date(formValues.purchaseDate);
        return (
          startDate >= purchaseDate ||
          "Depreciation Start Date must be on or after the Purchase Date"
        );
      },
    },
  },
  assetLife: {
    required: "Asset Life is required",
    validate: {
      isPositiveInteger: (value) =>
        (/^\d+$/.test(value) && parseInt(value) > 0) ||
        "Asset Life must be a positive whole number",
      isWithinRange: (value) => {
        const numValue = parseInt(value);
        return (
          (numValue >= 1 && numValue <= 100) ||
          "Asset Life must be between 1 and 100"
        );
      },
    },
  },
  assetLifeType: {
    required: "Asset Life Type is required",
  },
  assetAccount: {
    required: "Asset Account is required",
  },
  accumulatedDepreciationAccount: {
    required: "Accumulated Depreciation Account is required",
  },
  depreciationExpenseAccount: {
    required: "Depreciation Expense Account is required",
  },
};

// Forgot Password and Reset Password Validation Schemas
export const ForgotPasswordValidate = {
  email: {
    required: true,
    validator: {
      regEx: isEmail,
      error: "Please enter a valid email",
      errEmpty: "Email is required",
    },
  },
};

export const OtpValidate = {
  otp: {
    required: true,
    validator: {
      regEx: /^[0-9]{6}$/,
      error: "Please enter a valid 6-digit OTP",
      errEmpty: "OTP is required",
    },
  },
};

export const ResetPasswordValidate = {
  newPassword: {
    required: true,
    validator: {
      regEx: isPassword,
      error:
        "Password must be at least 8 characters long, include one uppercase letter, one lowercase letter, one number, and one special character. Spaces are not allowed.",
      errEmpty: "New Password is required",
    },
  },
  confirmPassword: {
    required: true,
    validator: {
      errEmpty: "Confirm Password is required",
    },
  }
};
